// =========================================================
// frontend/js/company.js - Verwaltung der Firmendaten
// =========================================================

window.renderCompanyHTML = async function() {
    const user = window.currentUser;
    if (!user || !user.companyId) {
        return `<div class="p-10 text-center text-red-500 font-bold">Fehler: Keine Unternehmenszuordnung gefunden.</div>`;
    }

    const cid = user.companyId;
    let companyData = {};
    
    try {
        const doc = await db.collection('companies').doc(cid).get();
        if (doc.exists) companyData = doc.data();
    } catch (e) {
        console.error("Fehler beim Laden der Firmendaten:", e);
    }

    return `
        <div class="p-10 max-w-5xl animate-fadeIn">
            <div class="mb-10">
                <h3 class="text-3xl font-black text-slate-800 tracking-tighter flex items-center gap-3">
                    <i data-lucide="building-2" class="text-blue-600 w-8 h-8"></i> Unternehmens-Daten
                </h3>
                <p class="text-slate-400 font-bold uppercase tracking-widest text-[10px] mt-1">Zentrale Verwaltung der Organisation</p>
            </div>

            <div class="bg-white rounded-[2.5rem] border border-slate-100 p-10 shadow-sm space-y-8">
                <div class="space-y-1">
                    <label class="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Name des Unternehmens</label>
                    <input type="text" id="comp-name" value="${companyData.name || ''}" placeholder="Firmenname" 
                           class="w-full px-6 py-4 bg-slate-50 border-2 border-slate-50 rounded-2xl font-bold text-slate-700 outline-none focus:border-blue-500 transition-all">
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div class="space-y-1">
                        <label class="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Branche</label>
                        <input type="text" id="comp-branch" value="${companyData.industry || ''}" placeholder="z.B. IT, Marketing..." 
                               class="w-full px-6 py-4 bg-slate-50 border-2 border-slate-50 rounded-2xl font-bold text-slate-700 outline-none">
                    </div>
                    <div class="space-y-1">
                        <label class="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Mitarbeiteranzahl</label>
                        <select id="comp-size" class="w-full px-6 py-4 bg-slate-50 border-2 border-slate-50 rounded-2xl font-bold text-slate-700 outline-none appearance-none">
                            <option value="1-10" ${companyData.size === '1-10' ? 'selected' : ''}>1-10 MA</option>
                            <option value="11-50" ${companyData.size === '11-50' ? 'selected' : ''}>11-50 MA</option>
                            <option value="51-250" ${companyData.size === '51-250' ? 'selected' : ''}>51-250 MA</option>
                            <option value="250+" ${companyData.size === '250+' ? 'selected' : ''}>250+ MA</option>
                        </select>
                    </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
                    <div class="md:col-span-3 space-y-1">
                        <label class="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Straße</label>
                        <input type="text" id="comp-street" value="${companyData.street || ''}" placeholder="Strasse" class="w-full px-6 py-4 bg-slate-50 border-2 border-slate-50 rounded-2xl font-bold">
                    </div>
                    <div class="space-y-1">
                        <label class="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Nr.</label>
                        <input type="text" id="comp-nr" value="${companyData.streetno || ''}" placeholder="Hausnummer" class="w-full px-6 py-4 bg-slate-50 border-2 border-slate-50 rounded-2xl font-bold">
                    </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div class="space-y-1">
                        <label class="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">PLZ</label>
                        <input type="text" id="comp-zip" value="${companyData.postalcode || ''}" placeholder="Postleitzahl" class="w-full px-6 py-4 bg-slate-50 border-2 border-slate-50 rounded-2xl font-bold">
                    </div>
                    <div class="md:col-span-2 space-y-1">
                        <label class="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Ort</label>
                        <input type="text" id="comp-city" value="${companyData.city || ''}" placeholder="Ort" class="w-full px-6 py-4 bg-slate-50 border-2 border-slate-50 rounded-2xl font-bold">
                    </div>
                </div>

                <div class="space-y-1 pt-4 border-t border-slate-50">
                    <label class="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">UST-ID-Nr.</label>
                    <input type="text" id="comp-ustid" value="${companyData.ustId || ''}" placeholder="DE123456789" class="w-full px-6 py-4 bg-slate-50 border-2 border-slate-50 rounded-2xl font-bold text-slate-700 outline-none">
                </div>

                <div class="pt-6">
                    <button onclick="window.saveCompanyData(event)" class="w-full md:w-auto bg-emerald-600 hover:bg-black text-white px-12 py-5 rounded-2xl font-black uppercase text-xs tracking-widest transition-all flex items-center justify-center gap-3 shadow-xl shadow-emerald-100">
                        <i data-lucide="save"></i> Firmendaten sichern
                    </button>
                </div>
            </div>
        </div>
    `;
};

window.saveCompanyData = async function(event) {
    const user = window.currentUser;
    if (!user || !user.companyId) return;

    const btn = event ? event.currentTarget : null;
    const originalHTML = btn ? btn.innerHTML : '<i data-lucide="save"></i> Firmendaten sichern';

    const cid = user.companyId;
    
    const nameField = document.getElementById('comp-name');
    if (!nameField) return;

    // FIX: Wir verwenden hier beim Speichern wieder die exakt selben Keys wie in der auth.js
    const newData = {
        name: nameField.value,
        industry: document.getElementById('comp-branch')?.value || '',
        size: document.getElementById('comp-size')?.value || '',
        street: document.getElementById('comp-street')?.value || '',
        streetno: document.getElementById('comp-nr')?.value || '',
        postalcode: document.getElementById('comp-zip')?.value || '',
        city: document.getElementById('comp-city')?.value || '',
        ustId: document.getElementById('comp-ustid')?.value || ''
    };

    try {
        if (btn) {
            btn.disabled = true;
            btn.innerHTML = '<i class="animate-spin" data-lucide="loader-2"></i> Speichere...';
            if(window.lucide) lucide.createIcons();
        }

        await db.collection('companies').doc(cid).set(newData, { merge: true });
        
        // Kleine Rückmeldung, dass es geklappt hat!
        if(window.showToast) {
            window.showToast("Unternehmensdaten erfolgreich aktualisiert! 🏢");
        } else {
            alert("Unternehmensdaten erfolgreich aktualisiert! 🏢");
        }
        
    } catch (error) {
        console.error("Fehler beim Speichern der Firmendaten:", error);
        alert("Fehler beim Speichern. Hast du die nötigen Berechtigungen?");
    } finally {
        if (btn) {
            btn.disabled = false;
            btn.innerHTML = originalHTML;
            if(window.lucide) lucide.createIcons();
        }
    }
};